import React from 'react';
import { Row, Col } from '../../util_grid/grid.js';
import Layout_base from './layout-base.jsx';

class Layout_four_md  extends Layout_base {
  render() {
    return (
      <Col xs={12}>
        {this.sectionHead()}
        <Row>
          <Col md={3}>{this.componentDOM(0)}</Col>
          <Col md={3}>{this.componentDOM(1)}</Col>
          <Col md={3}>{this.componentDOM(2)}</Col>
          <Col md={3}>{this.componentDOM(3)}</Col>
        </Row>
        {this.sectionFooter()}
      </Col>
    );
  }
}

export default Layout_four_md;
